import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { Page, PageRequestParams } from '../../common/queryClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { ProcessingEventDirectoryEntryType } from '../schema/types';
import { ProcessingEventUrl } from './ProcessingEventUrl';
import {
  ProcessingEventDirectoryPageSchema,
  ProcessingEventsFilter,
} from './useInputProcessingEventsQuery';

const getOutputProcessingEvents = (
  params: Partial<ProcessingEventsFilter> & PageRequestParams
) =>
  apiClient
    .get<Page<ProcessingEventDirectoryEntryType>>(
      expand(ProcessingEventUrl.OUTPUT_PROCESSING_EVENTS, params)
    )
    .then((response) =>
      ProcessingEventDirectoryPageSchema.parse(response.data)
    );

export const useOutputProcessingEventsQuery = createApiQueryHook(
  ['outputProcessingEvents'],
  getOutputProcessingEvents
);
